import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, MapPin, Phone } from 'lucide-react';
export function FitnessHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-1426">
      <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1427">
        <Activity className="w-4 h-4" data-id="element-1428" />
        Fitness-Focused Taekwondo
      </div>

      <div className="mb-8 inline-flex flex-nowrap items-center gap-3 text-sm md:text-base font-bold text-ink bg-white/90 backdrop-blur-sm py-2 px-4 rounded-full shadow-sm border border-subtle-gray w-fit max-w-full whitespace-nowrap" data-id="element-1429">
        <span className="text-gold tracking-wider shrink-0" data-id="element-1430">★★★★★</span>
        <span className="text-subtle-gray shrink-0" data-id="element-1431">|</span>
        <span className="shrink-0" data-id="element-1432">5.0 Rating From 201 Reviews</span>
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1]" data-id="element-1433">
        Are Martial Arts Good for Fitness?
      </h1>

      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-1434">
        Storm Taekwondo helps kids, adults, and families build strength,
        flexibility, endurance, balance, discipline, and confidence through
        structured Taekwondo classes in Farmington Hills.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-1435">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-1436">
          Start With a Trial Class
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary flex items-center justify-center gap-2" data-id="element-1437">
          <Phone className="w-5 h-5" data-id="element-1438" />
          Call 517-220-0621
        </a>
      </div>

      <div className="flex items-start gap-3 text-off-white/80 text-sm" data-id="element-1439">
        <MapPin className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-1440" />
        <p data-id="element-1441">
          Conveniently located at 24786 Crestview, Farmington Hills, MI 48335.
          <br data-id="element-1442" />
          Serving Novi, Commerce, Walled Lake, Wixom, Livonia, Northville, and
          Waterford.
        </p>
      </div>
    </div>;
}